import dayjs, { Dayjs } from "dayjs"

export const formatDate = (date: Dayjs): string => {
  return date.format("DD MMM YYYY")
}

export const safeDate = (
  value: string | Dayjs | null | undefined
): Dayjs | undefined => {
  return value ? dayjs(value) : undefined
}
